import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { FormControl, Select } from '@ha/dsl';
import { useIntl } from 'ha/i18n';
import { MenuItem } from 'ha/components/Menu/MenuItem';
import { getCountriesOptions } from 'ha/utils/getCountriesOptions';
import { LIST_OF_COUNTRIES } from 'ha/pages/SupportUkraine/constants';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const useStyles = makeStyles()(theme => ({
  defaultValueSelect: {
    color: theme.palette.grey['400'],
  },
  defaultValueOption: {
    display: 'none',
  },
}));

const CountryFilter: React.FC<Props> = ({ value, onChange }) => {
  const { T, locale } = useIntl();
  const { classes } = useStyles();

  const handleCountryChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    },
    [onChange],
  );

  const handleCountryClosed = React.useCallback(() => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }, []);

  const isDefaultCountryValue = value === '';

  const countryOptions = getCountriesOptions(T, locale).filter(
    option => option.value === '' || LIST_OF_COUNTRIES[option.value],
  );

  return (
    <FormControl margin="dense" fullWidth variant="outlined" hiddenLabel>
      <Select
        displayEmpty
        margin="dense"
        value={value}
        onChange={handleCountryChange}
        className={
          isDefaultCountryValue ? classes.defaultValueSelect : undefined
        }
        MenuProps={{
          TransitionProps: {
            onExited: handleCountryClosed,
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        }}
      >
        {countryOptions.map(option => (
          <MenuItem
            key={option.title}
            value={option.value}
            disabled={option.disabled}
          >
            {option.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export { CountryFilter };
